<div id="appHeader">
  <nav
    class="
      navbar navbar-expand-lg navbar-dark navbar-absolute
      px-lg-3 px-md-3 px-sm-3
    "
  >
    <a class="navbar-brand" (click)="brandNavigate()">
      <img
        src="./assets/img/tila_logo.svg"
        class="d-inline-block align-middle img-fluid ms-4 me-2"
        alt="brand_logo"
      />
    </a>

    <button
      mat-stroked-button
      class="navbar-toggler bg-transparent"
      type="button"
      (click)="sidebarToggle()"
    >
      <span class="sr-only d-none">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse" id="collapsibleNavId">
      <ul
        class="navbar-nav me-auto mt-2 mt-lg-0 nav-tabs-list"
        *ngIf="showTopbar"
      >
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="['/features/retailers/addretailer']"
            routerLinkActive="router-link-active"
            *hideIfUnauthorized="'Add Retailer'"
            translate
            >pages.sidebar.AddRetailer</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="['/features/promotions']"
            routerLinkActive="router-link-active"
            translate
            *hideIfUnauthorized="'Promotions'"
            >pages.sidebar.Promotions</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="['./retailer-portal']"
            routerLinkActive="router-link-active"
            *hideIfUnauthorized="'retailerportal'"
            translate
            >pages.sidebar.RetailerPortal</a
          >
        </li>
      </ul>
      <ul class="navbar-nav ms-auto nav-right-actions">
        <li class="nav-item" *ngIf="showTopbar && showinner && showConnectionService" >
          <div style="color:white;" *hideIfUnauthorized="'Connection To Services'">
            <label>Connected to</label>
            <a class="nav-link"  style="text-align:center; padding: 0rem; text-decoration:underline" (click)="changePlatform()">
              {{ connectionFlag === true ? "SMART PIR" : "CellPay" }}
            </a>
          </div>
        </li>
        <li class="nav-item" *ngIf="showTopbar && showinner">
          <a
            class="nav-link"
            routerLinkActive="router-link-active"
            (click)="messagesCount = 0; navigatetoMessages()"
          >
            <span
              *ngIf="messagesCount > 0; else noNotifications"
              matBadge="{{ messagesCount }}"
              matBadgeColor="warn"
              class="mi mi-mail-outline" 
            ></span>
            <ng-template #noNotifications>
              <span class="mi mi-mail-outline"></span>
            </ng-template>
          </a>
        </li>

        <li class="nav-item" *ngIf="showTopbar && showinner">
          <a
            class="nav-link"
            [routerLink]="['./profile']"
            routerLinkActive="router-link-active"
          >
            <span class="mi mi-person me-2"></span> {{ userName }}
          </a>
        </li>
        <li class="nav-item" *ngIf="!showTopbar || showinner">
          <a
            class="nav-link cur-point p-0 lang-holder"
            [matMenuTriggerFor]="menu"
            ><img
              src="./assets/img/language.svg"
              matPrefix
              alt="language_icon"
              class="img-fluid lang-icon"
            />
            {{ preferredLanguage == "es" ? "Español" : "English" }}
            <i matSuffix class="mi mi-arrow-drop-down mt-2"></i>
          </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onChnageLanguage('en')">
              English
            </button>
            <button mat-menu-item (click)="onChnageLanguage('es')">
              Español
            </button>
          </mat-menu>
        </li>
        <li class="nav-item" *ngIf="showTopbar && showinner">
          <a class="nav-link" (click)="onLogout()">
            <span class="mi mi-logout cur-point"></span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</div>
